<template>
	<v-dialog :model-value="visible" width="800" persistent>
		<v-card>
			<v-card-title>{{ title }}</v-card-title>
			<v-card-text class="pa-8">
				<span>{{ $t('add_comment') }}</span>
				<v-textarea rows="1" v-model="comment" hide-details auto-grow></v-textarea>
			</v-card-text>
			<v-card-actions class="pb-3">
				<v-btn variant="text" @click="handleClose(false)">
					{{ $t('action_cancel') }}
				</v-btn>
				<v-spacer></v-spacer>
				<v-btn v-if="!isPreviewActive" :color="buttonConfig.color" variant="flat" @click="handleAction">
					{{ buttonConfig.text }}
				</v-btn>

				<v-btn
					v-if="showPreview"
					variant="flat"
					color="teal-darken-4"
					:loading="previewButtonLoading"
					@click="() => handlePreviewButtonClick(() => handleAction())"
				>
					<v-progress-circular v-if="previewButtonLoading" indeterminate size="18" width="2" />
					<span v-else>{{ $t(previewButtonLabelKey) }}</span>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDutyChangePreview } from '@/rennovation/planning-view/composables/useDutyChangePreview';

const { t } = useI18n();
const { previewButtonLoading, previewButtonLabelKey, handlePreviewButtonClick } = useDutyChangePreview();

const props = defineProps({
	visible: {
		type: Boolean,
		default: false,
	},
	title: {
		type: String,
		required: true,
	},
	actionType: {
		type: String,
		default: 'save',
	},
	showPreview: {
		type: Boolean,
		default: false,
	},
	isPreviewActive: {
		type: Boolean,
		default: false,
	},
});

const emit = defineEmits(['update', 'submit', 'delete', 'unassign']);

const comment = ref('');

const buttonConfig = computed(() => {
	switch (props.actionType) {
		case 'delete':
			return { color: 'error', text: t('action_delete'), emit: 'submit' };
		case 'unassign':
			return { color: 'warning', text: t('duty_unassign'), emit: 'submit' };
		default:
			return { color: 'primary-green', text: t('action_save'), emit: 'submit' };
	}
});

const handleClose = (val = false) => {
	comment.value = '';
	emit('update', val);
};

const handleAction = () => {
	emit(buttonConfig.value.emit, comment.value.trim());
	comment.value = '';
};
</script>
